import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "tr_cookie_consent";

export const CookieBanner = () => {
  const { user } = useAuth();
  const [consent, setConsent] = useState(() => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } });
  const [custom, setCustom] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: false, marketing: false });

  useEffect(() => {
    const open = () => { setConsent(null); setCustom(true); };
    window.addEventListener("tr:cookies", open);
    return () => window.removeEventListener("tr:cookies", open);
  }, []);

  const save = async (c) => {
    const value = { necessary: true, ...c, at: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(value));
    setConsent(value);
    if (user) api.put("/auth/consents", { cookies_analytics: c.analytics, cookies_marketing: c.marketing }).catch(() => {});
  };

  if (consent) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-[60] md:left-auto md:right-6 md:bottom-6 md:max-w-md surface p-5 shadow-2xl backdrop-blur-xl bg-card/95" data-testid="cookie-banner">
      <div className="flex items-center gap-2 font-display font-semibold"><Cookie className="h-4 w-4 text-primary" />Sua privacidade</div>
      <p className="mt-2 text-sm text-muted-foreground">
        Usamos cookies estritamente necessários para manter sua sessão segura. Cookies opcionais só são usados com seu consentimento (LGPD).{" "}
        <Link to="/legal/cookies" className="text-primary underline">Política de cookies</Link>
      </p>
      {custom && (
        <div className="mt-4 space-y-3 text-sm">
          <div className="flex justify-between"><span>Necessários (sempre ativos)</span><Switch checked disabled /></div>
          <div className="flex justify-between"><span>Análise de uso</span><Switch data-testid="cookie-analytics-switch" checked={prefs.analytics} onCheckedChange={(v) => setPrefs({ ...prefs, analytics: v })} /></div>
          <div className="flex justify-between"><span>Marketing</span><Switch data-testid="cookie-marketing-switch" checked={prefs.marketing} onCheckedChange={(v) => setPrefs({ ...prefs, marketing: v })} /></div>
        </div>
      )}
      <div className="mt-4 flex flex-wrap gap-2">
        <Button size="sm" data-testid="cookie-accept-all" onClick={() => save({ analytics: true, marketing: true })}>Aceitar todos</Button>
        <Button size="sm" variant="outline" data-testid="cookie-reject" onClick={() => save({ analytics: false, marketing: false })}>Somente necessários</Button>
        {custom
          ? <Button size="sm" variant="ghost" data-testid="cookie-save" onClick={() => save(prefs)}>Salvar escolhas</Button>
          : <Button size="sm" variant="ghost" data-testid="cookie-customize" onClick={() => setCustom(true)}>Personalizar</Button>}
      </div>
    </div>
  );
};
